/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/sabotage_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22.207 13.5h-3L13.5 19.207v3l-2.146 2.146-.707-.707 1.854-1.854V19.5h-2.293l-1.854 1.854-.707-.707L9.793 18.5h3l5.707-5.707v-3l2.146-2.146.707.707-1.853 1.853V12.5h2.293l1.854-1.854.707.707-2.147 2.147z"/>'
  }
})
